// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__S0NPW","overly":"styles_overly__5q+7x","inner":"styles_inner__-yoXB","withCrossBtn":"styles_withCrossBtn__cxc7h","cross":"styles_cross__oOg7P"};